export function categoryListing(config) {
  return {
    loading: true,
    hasEvents: true,

    async init() {
      const wrapper = this.$el;

      try {
        const params = new URLSearchParams({ slug: config.slug });
        params.set("displayAvailable", config.displayAvailable);
        if (config.titleClass) params.set("titleClass", config.titleClass);
        if (config.textClass) params.set("textClass", config.textClass);
        if (config.subtitleClass)
          params.set("subtitleClass", config.subtitleClass);

        const separator = config.actionUrl.includes("?") ? "&" : "?";
        const response = await fetch(
          config.actionUrl + separator + params.toString(),
        );
        if (!response.ok) throw new Error(response.statusText);
        const data = await response.json();

        if (data.count === 0) {
          this.hasEvents = false;
          this.loading = false;
          return;
        }

        // Fade out placeholders
        wrapper.classList.add("transition-opacity", "duration-300");
        wrapper.classList.add("opacity-0");

        await new Promise((resolve) => setTimeout(resolve, 300));

        this.$refs.listing.innerHTML = data.html;
        this.loading = false;

        // Fade in real content
        requestAnimationFrame(() => {
          wrapper.classList.remove("opacity-0");
        });
      } catch {
        this.hasEvents = false;
        this.loading = false;
      }
    },
  };
}
